export default {"src":"/_next/static/media/0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};